export default __webpack_public_path__ + "images/checkGreenSquare.v-39d289376daa3a2cef51cf1af981bae1.svg";